
import React from 'react'
import { Tabs, Form, Button, message, Tooltip } from 'antd';
import Config from '../../config/Config';
import Widget from '../../widget/Widget';
import WidgetAjax from '../../widget/WidgetAjax';
import NoData from '../com/NoData';
let path = Config.getBasePath();
let sourcePath = Config.getSourcePath();
class favorite extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tabData: [
        { key: '1', label: '职业规划' },
        { key: '2', label: '职业测评' },
        { key: '3', label: '职业探索' },
      ],
      tabValue: '1',
      data1: [
        { name: '探索职业道路', context: '打造的AI职业教练，其背后是拥有超十年职业指导经验的专家团队。凭借来自超过15万名专业志愿者的见解以及20多家职业发展机构的建议，Coach能够基于海量数据提供个性化建议。它通过安全的数据管理确保你的隐私安全，并让你掌控自己的信息。此外，Coach由CareerVillage.org团队进行审核和监督，以保证平台的安全性和可靠性。' },
        { name: '探索职业道路1', context: '打造的AI职业教练，其背后是拥有超十年职业指导经验的专家团队。凭借来自超过15万名专业志愿者的见解以及20多家职业发展机构的建议，Coach能够基于海量数据提供个性化建议。它通过安全的数据管理确保你的隐私安全，并让你掌控自己的信息。此外，Coach由CareerVillage.org团队进行审核和监督，以保证平台的安全性和可靠性。' },
      ],
      data2: [
        { name: "职业技能测试模版1", time: '20-50分钟', context: '通过初始的职业技能学习，了解更多职业专业技能，并制定学习计划培养独立自主的学习习惯，应对未来不确定性。' },
        { name: "职业技能测试模版2", time: '20-50分钟', context: '通过初始的职业技能学习，了解更多职业专业技能，并制定学习计划培养独立自主的学习习惯，应对未来不确定性。' },
        { name: "职业技能测试模版3", time: '20-50分钟', context: '通过初始的职业技能学习，了解更多职业专业技能，并制定学习计划培养独立自主的学习习惯，应对未来不确定性。' },
        { name: "职业技能测试模版4", time: '20-50分钟', context: '通过初始的职业技能学习，了解更多职业专业技能，并制定学习计划培养独立自主的学习习惯，应对未来不确定性。' },
        { name: "职业技能测试模版4", time: '20-50分钟', context: '通过初始的职业技能学习，了解更多职业专业技能，并制定学习计划培养独立自主的学习习惯，应对未来不确定性。' }
      ],
      data3: [
        { name: '大数据工程技术开发', context: '将软件产品销售给客户，并满足客户需求的过程。软件销售人员需要了解客户的需求，并向他们介绍适合的产品。' },
        { name: '大数据工程技术开发', context: '将软件产品销售给客户，并满足客户需求的过程。软件销售人员需要了解客户的需求，并向他们介绍适合的产品。' },
      ]
    }

  }

  componentDidMount() {

  }



  getUserInfo = () => {
    const onGetUser = (res) => {
      if (res.status == 0) {
        this.setState({ user_info: res.result });
        this.form.setFieldsValue(res.result)
      }
    }
    WidgetAjax.ajax({ url: path + "/info", callback: onGetUser })
  }



  render() {

    const { tabData, tabValue, data1, data2, data3 } = this.state;
    return <div>
      <div className='controlPanel  favorite'>
        <Tabs activeKey={tabValue} items={tabData} onChange={(value) => { this.setState({ tabValue: value }) }} />
        {
          tabValue === '1' ?

            <div className='plan-list'>
              {
                data1 && data1.length > 0 ?
                  data1.map((item) => {
                    return <div className='plan-list-item'>
                      <img style={{ height: '40px', width: '40px' }} src={require("./../../img/" + sourcePath + "/ai-chat/ai-user.png")}></img>
                      <div className='plan-list-item-box'>
                        <div className='item-head'>
                          <div className='item_name'>{item.name}</div>
                          <span>保存时间：2025年4月24日</span>
                        </div>
                        <div className='item_content'> {item?.context} </div>
                      </div>
                    </div>
                  })
                  : <NoData />
              }
            </div>

            : tabValue === '2' ?
              <div className='evaluation-list'>
                {
                  data2 && data2.length > 0 ?
                    data2.map((item) => {
                      return <div className='evaluation-item'>
                        <div className='evaluation-head'> <img src={require("../../img/pinzhunzhun/career/evaluation.png")} /></div>
                        <div className='evaluation-body'>
                          <div className='evaluation-body-title'><div className='name'>{item.name}</div><span>{item?.time}</span></div>
                          <div className='evaluation-body-content'>{item?.context}</div>
                          <div className='evaluation-op'>
                            <a>取消收藏</a>
                          </div>
                        </div>
                      </div>
                    })
                    : <NoData />
                }
              </div>
              : <div className='explore-list'>
                {
                  data3 && data3.length > 0 ?
                    data3.map((item) => {
                      return <div className='explore-list-item'>
                        <img className='explore-item-logo' src={require("../../img/pinzhunzhun/career/career-evaluation.png")} />
                        <div className='explore-item-box'>
                          <div className='explore-name'>{item?.name}</div>
                          <div className='explore-content'>{item?.context}</div>
                          <div className='explore-analyse'>
                            <div className='item'>
                              <img src={require("../../img/pinzhunzhun/ai-chat/bookmark1.png")} /> 12
                            </div>
                            <div className='item'>
                              <img src={require("../../img/pinzhunzhun/ai-chat/thumb-up1.png")} /> 12
                            </div>
                          </div>
                        </div>
                      </div>
                    })
                    : <NoData />
                }
              </div>

        }

      </div>





    </div>
  }
}

export default favorite;